export const timeRegistrationCode = ['login', 'logout', 'startbreak'] as const;
export type TimeRegistrationCode = (typeof timeRegistrationCode)[number];
